import React, { useMemo } from 'react';

import ProductAdderBody from '@src/components/Product/ProductAdderBody';
import { useAppSelector, useTranslate } from '@src/core/hooks';
import { currentProductAdderStatus, productAdderStepState, productPackageStatusSelector } from '@src/features/product';
import { useWidgetId } from '@src/core/IdProvider';

import { Container, ImageContainer, SelectionArea, SelectionTitle } from './styles';
import usePackage from '@src/hooks/usePackage';
import SpinnerBar from '@src/components/reusable/spinner/SpinnerBar';
import ProductPackageCompletedSummary from '../ProductPackageCompletedSummary';
import usePackageIdParam from '@src/hooks/usePackageIdParam';

const ProductPackageAdderBody = () => {
  const { i18n } = useTranslate();
  const widgetId = useWidgetId();
  const packageId = usePackageIdParam();

  const { currentStep } = useAppSelector(productAdderStepState(widgetId));
  const status = useAppSelector(productPackageStatusSelector(packageId!));
  const currentAdderStatus = useAppSelector(currentProductAdderStatus(widgetId));

  const { selectedProduct, loadingProduct } = usePackage();

  const selectionStepText = useMemo(() => {
    const stepTexts = {
      calendar: i18n('product_package_adder_selection_step_calendar'),
      tariff: i18n('product_package_adder_selection_step_tariff'),
      seat_map: i18n('product_package_adder_selection_step_seat_map'),
      additional: i18n('product_package_adder_selection_step_additional'),
    };
    return currentStep ? stepTexts[currentStep as keyof typeof stepTexts] : '';
  }, [currentStep, i18n]);

  if (status === 'completed' && currentAdderStatus === 'ongoing') {
    return <ProductPackageCompletedSummary />;
  }

  if (loadingProduct) {
    return (
      <Container>
        <SpinnerBar />

        <p>{i18n('base_loading')}</p>
      </Container>
    );
  }

  return (
    <SelectionArea>
      <SelectionTitle>
        {selectedProduct?.thumbnailUrl ? (
          <ImageContainer>
            <img src={selectedProduct?.thumbnailUrl} alt='product thumbnail' />
          </ImageContainer>
        ) : null}

        {selectionStepText}
        {selectedProduct?.name ?? ''}
      </SelectionTitle>

      <ProductAdderBody />
    </SelectionArea>
  );
};

export default ProductPackageAdderBody;
